import React from "react";
import styled from "styled-components";
import { prop } from "styled-tools";

/*
 * Styles
 */

/* Container */

const Container = styled.div`
  bottom: 5.6rem;
  display: flex;
  justify-content: space-between;
  left: 0rem;
  position: absolute;
  top: 0;
  right: 0rem;

  @media (min-width: 40em) {
    left: 4.8rem;
    right: 4.8rem;
  }
  @media (min-width: 68em) {
    left: 8rem;
    right: 8rem;
  }
`;

/* Axis */

const Axis = styled.div`
  background: ${prop("theme.colors.grayTT")};
  font-size: ${prop("theme.scale.down2")};
  height: 100%;
  width: 2px;
  position: relative;
  span {
    position: absolute;
    left: 50%;
    text-align: center;
    top: calc(100% + 0.4rem);
    transform: translateX(-50%);
  }
  &:nth-child(2) {
    span {
      left: 0;
      transform: none;
    }
  }
  &:nth-child(6) {
    span {
      left: auto;
      right: 0;
      transform: none;
    }
  }

  @media (min-width: 68em) {
    span {
      top: calc(100% + 1.2rem);
    }
  }
`;

/* Label */

const Label = styled.h4`
  font-size: ${prop("theme.scale.down2")};
  font-weight: bold;
  left: 0;
  letter-spacing: 0.125em;
  margin: 0;
  position: absolute;
  text-transform: uppercase;
  top: calc(100% + 1.6rem);

  &:last-child {
    left: auto;
    right: 0;
    &::after {
      background: linear-gradient(
        to left,
        #869ba1,
        ${prop("theme.colors.blueT")},
        ${prop("theme.colors.grayTTTT")}
      );
      left: auto;
      right: 0;
    }
  }

  &::after {
    background: linear-gradient(
      to right,
      ${prop("theme.colors.orange")},
      ${prop("theme.colors.orangeT")},
      ${prop("theme.colors.grayTTTT")}
    );
    content: "";
    left: 0;
    height: 0.4rem;
    position: absolute;
    top: 100%;
    width: 8rem;
  }

  @media (min-width: 40em) {
    left: -5.6rem;
    top: calc(100% + 0.4rem);
    &:last-child {
      left: auto;
      right: -5.6rem;
    }
    &::after {
      top: calc(100% + 0.4rem);
    }
  }
  @media (min-width: 68em) {
    left: -8rem;
    top: calc(100% + 1.2rem);
    &:last-child {
      left: auto;
      right: -8rem;
    }
  }
`;

/*
 * Component
 */

const BarLabels = () => (
  <Container aria-hidden="true">
    <Label>Disagree</Label>
    <Axis>
      <span>100</span>
    </Axis>
    <Axis>
      <span>50</span>
    </Axis>
    <Axis>
      <span>0%</span>
    </Axis>
    <Axis>
      <span>50</span>
    </Axis>
    <Axis>
      <span>100</span>
    </Axis>
    <Label>Agree</Label>
  </Container>
);

export default BarLabels;
